import { forEach, $, $all, getDataAttr, setDataAttr } from "@olmokit/dom";
import { lazyClass } from "@olmokit/core/lazy";
import "./sizes.scss";

/**
 * Load product sizes images responsively
 *
 * @param {string} containerSelector
 * @param {function} [callback]
 */
export default function loadSizesImages(containerSelector, callback) {
  const container = $(containerSelector);
  const images = $all("[data-manual-src]", container);
  const howMany = images.length;
  const map = {};
  let toLoad = howMany;

  forEach(images, (el) => {
    el.className += ` ${lazyClass}`;
    const dummy = new Image();
    const src = getDataAttr(el, "manual-src");
    dummy.src = src;

    map[src] = {
      el,
      src,
    };

    dummy.onload = function () {
      map[src].width = this.width;
      map[src].height = this.height;
      toLoad--;
      if (toLoad === 0) {
        onAllLoaded();
      }
    };
  });

  /**
   * Once all images are loaded
   */
  function onAllLoaded() {
    // const containerWidth = container.offsetWidth;

    for (const src in map) {
      if (map.hasOwnProperty(src)) {
        const { el, width, height } = map[src];
        el.width = width / 1.9;
        el.height = height / 1.9;
        setDataAttr(el, "src", src);
      }
    }

    // new Lazy({ container });
    callback(container);
  }
}
